import React from 'react';
import './Vision.css';
import vision01 from '../assets/images/vision-01.png.png';
import vision02 from '../assets/images/vision-02.png.png';
import vision03 from '../assets/images/vision-03.png.png';
import vision04 from '../assets/images/vision-04.png.png';
import vision05 from '../assets/images/vision-05.png.png';

function Vision() {
  const visionItems = [
    {
      number: '01',
      image: vision01,
      title: 'Greener Grid Energy',
      description: 'with sustainable and reliable power for Gurgaon and Manesar',
    },
    {
      number: '02',
      image: vision02,
      title: 'Reduced Carbon Footprint',
      description: 'of Energy generation & Distribution within Gurgaon & Manesar & supply round the clock (24/7) Green Energy',
    },
    {
      number: '03',
      image: vision03,
      title: 'Implementation of Smart Meter & Smart Grid',
      description: 'and cutting edge technologies to reduce technical and commercial losses',
    },
    {
      number: '04',
      image: vision04,
      title: 'Phase-out Diesel utilization',
      description: 'Phase out of Diesel and Gas based generators leading to substantial reduction in carbon emission',
    },
    {
      number: '05',
      image: vision05,
      title: 'Cost-Effective Pricing',
      description: 'with more efficient distribution system with cutting edge technology and infrastructure as its back bone',
    },
  ];

  return (
    <section className="vision">
      <div className="vision-container">
        <div className="vision-left">
          <h2>Our<br /> Vision</h2>
          {/* <p>Eleven Power brings together a utility mindset, retail consumer orientation, and technology-led operating approach to serve the evolving needs of modern power consumers.</p> */}
        </div>

        <div className="vision-grid">
          {visionItems.map((item, index) => (
            <div key={index} className={`vision-item vision-item-${item.number}`}>
              <span className="vision-number">{item.number}</span>
              <div className="vision-icon">
                <img src={item.image} alt={item.title} />
              </div>
              <h3>{item.title}</h3>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Vision;
